// extracted by mini-css-extract-plugin
module.exports = {"card":"services_card__q_DpW","shape":"services_shape__6Osh4","content":"services_content__m9oNQ","images":"services_images__NYDOm","borderSection":"services_borderSection__sLCWL"};